"use strict";

exports.__esModule = true;
exports.minBreakpoints = exports.maxBreakpoints = exports.default = void 0;
var breakpoints = {
  xs: 540,
  sm: 720,
  md: 960,
  lg: 1140,
  xl: 1920,
  xxl: 2560
};
var SIZE_OFFSET = 1;
var minBreakpoints = exports.minBreakpoints = Object.assign({}, breakpoints);
var maxBreakpoints = exports.maxBreakpoints = {
  xs: breakpoints.xs - SIZE_OFFSET,
  sm: breakpoints.sm - SIZE_OFFSET,
  md: breakpoints.md - SIZE_OFFSET,
  lg: breakpoints.lg - SIZE_OFFSET,
  xl: breakpoints.xl - SIZE_OFFSET,
  xxl: breakpoints.xxl - SIZE_OFFSET
};
var _default = exports.default = breakpoints;